import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import riskAssessmentHistoryService from "../../services/riskAssessmentHistoryService";

const useRiskAssessmentVersionHistory = (riskAssessmentHistoryId) =>
    useQuery(
        [
            queryKeys.riskAssessmentVersionHistory,
            riskAssessmentHistoryId,
        ],
        () => riskAssessmentHistoryService.fetchRiskAssessmentVersionHistory(riskAssessmentHistoryId),
        {
            enabled: !!riskAssessmentHistoryId,
        }
    );

export default useRiskAssessmentVersionHistory;